import { useContext, useState } from "react";
import { FaAtom, FaFileInvoice, FaUser } from "react-icons/fa";
import Pager from "components/ui/controls/pager/pager";
import { AppContext } from "components/app/RemExprertProvider";
import ListeAudits from "components/app/Extranet/ListeAudits";
import CabinetManagement from "components/ui/layout/CabinetManagement";

import AdminPage from "pages/extranet/admin";
import InvoicesPage from "pages/extranet/invoices";

const AuditsPage = (props) => {
  const context = useContext(AppContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [showInvoices, setShowInvoices] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);
  // Handlers pour la gestion du cabinet
  const handlePreferences = () => {
    if (props.handleShowPreferences) {
      props.handleShowPreferences();
    } else {
      console.log('Envoi du message showPreferences...');
      window.top.postMessage({ Action: "showPreferences" }, "*");
    }
  };

  const handleInvoices = () => {
    console.log('Affichage des factures dans le menu...');
    setShowInvoices(true);
    setShowHelp(false);
    setShowAdmin(false);
    setTimeout(() => {
      const pages = getUpdatedPages(true, false, false);
      const invoiceIndex = pages.findIndex(page => page.label === "Factures");
      if (invoiceIndex !== -1) {
        setCurrentPage(invoiceIndex);
      }
    }, 0);
  };

  const handleHelp = () => {
    console.log('Ouverture de l\'aide vidéo MAKO...');
    // Ouvrir le lien YouTube MAKO dans une nouvelle fenêtre
    window.open('https://www.youtube.com/@MAKOLogiciels', '_blank');
  };

  const handleAdmin = () => {
    console.log('Affichage administration dans le menu...');
    setShowAdmin(true);
    setShowInvoices(false);
    setShowHelp(false);
    setTimeout(() => {
      const pages = getUpdatedPages(false, false, true);
      const adminIndex = pages.findIndex(page => page.label === "Administration");
      if (adminIndex !== -1) {
        setCurrentPage(adminIndex);
      }
    }, 0);
  };

  const handleGoHome = () => {
    console.log('Retour à l\'accueil extranet...');
    // Retourner directement à la page clients en modifiant le contexte
    context.handleValueChange("AccesSimulateur", false);
    context.handleValueChange("TypeSimulation", "");
    props.SetAccessEtude("");
  };

  // Fonction helper pour générer les pages avec les états donnés
  const getUpdatedPages = (invoices, help, admin) => {
    let pages = [
      {
        isTitle: true,
        title: "Extranet",
        subTitle: "Dossier client",
      },
      {
        label: context.state.Prenom+" "+context.state.Nom,
        icon: <FaUser />,
        content: <ListeAudits AccesEtude={props.AccesEtude} SetAccessEtude={props.SetAccessEtude} />,
      },
    ];

    if (invoices) {
      pages.push({
        label: "Factures",
        icon: <FaFileInvoice />,
        content: <InvoicesPage IdCabinet={context.state.IdCabinet} />,
      });
    }

    if (admin) {
      pages.push({
        label: "Administration",
        icon: <FaAtom />,
        content: <AdminPage AccessDossier={() => setShowAdmin(false)} />,
      });
    }

    pages.push({
      isCabinetManagement: true,
      content: <CabinetManagement 
      AccesEtude={props.AccesEtude} 
      SetAccessEtude={props.SetAccessEtude}
        onPreferences={handlePreferences}
        onInvoices={handleInvoices}
        onHelp={handleHelp}
        onAdmin={handleAdmin}
        onGoHome={handleGoHome}
        showGoHome={true}
      />,
    });

    return pages;
  };

  const handlePages = () => {
    return getUpdatedPages(showInvoices, showHelp, showAdmin);
  };

  return (
    <Pager
      withMenu
      pages={handlePages()}
      page={currentPage}
      onPageChange={(page) => {
        setCurrentPage(page);
      }}
      // navButtons={{
      //     'cancel' : { onClick: (evt) => { console.log('Cancel click')} },
      //     'previous' : { onClick: (evt) => { console.log('Previous click')} },
      //     'next' : { onClick: (evt) => { console.log('Next click')} },
      //     'validate' : { onClick: (evt) => { console.log('Validate click')} }
      // }}
      // customButtons={
      //     <Row fill>
      //         <Button onClick={(evt) => { console.log('Bouton supp click')}}>
      //             <FaCogs/>
      //             <span>Bouton supplémentaire</span>
      //         </Button>
      //     </Row>
      // }
    />
  );
};

export default AuditsPage;
